"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Radio.default;
  }
});

var _Radio = _interopRequireDefault(require("./Radio"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Radio/index.js
// module id = 416
// module chunks = 226573449209678